import React from 'react';

const Impact = () => {
  return (
    <div className="bg-gray-50 text-black py-10 sm:py-20 lg:py-20">
      <div className="max-w-6xl mx-auto px-6">
        
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-3 sm:mb-4">
            Impact
          </p>
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-6 sm:mb-8 leading-snug">
            Our Legacy <em>So Far</em>
          </h2>

          <p className="text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-3xl mx-auto text-gray-600">
            Driving growth and innovation for professionals and enterprises, empowering individuals 
            to excel and organizations to scale with practical AI training and custom implementation.
          </p>
        </div>

        {/* Impact Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 sm:gap-12">
          
          <div className="text-center">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-thin mb-2">10,000+</h3>
            <div className="w-8 h-px bg-black mx-auto mb-3 sm:mb-4"></div>
            <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-gray-500">
              Professionals Trained
            </p>
          </div>

          <div className="text-center">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-thin mb-2">10+</h3>
            <div className="w-8 h-px bg-black mx-auto mb-3 sm:mb-4"></div>
            <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-gray-500">
              Enterprises Supported
            </p>
          </div>

          <div className="text-center">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-thin mb-2">10+</h3>
            <div className="w-8 h-px bg-black mx-auto mb-3 sm:mb-4"></div>
            <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-gray-500">
              AI Solutions Deployed
            </p>
          </div>

          <div className="text-center">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-thin mb-2">96%</h3>
            <div className="w-8 h-px bg-black mx-auto mb-3 sm:mb-4"></div>
            <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase text-gray-500">
              Client Satisfaction
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Impact;
